import { SxProps } from '@mui/material';
import { CreateCSSProperties, createStyles, CSSProperties, makeStyles, PropsFunc } from '@mui/styles';
import { Colors } from 'copyright-clearance-center-common-ui';

// eslint-disable-next-line @typescript-eslint/ban-types
export declare type Styles = CSSProperties | CreateCSSProperties<{}> | PropsFunc<{}, CreateCSSProperties<{}>>;

export const textTruncate: Styles = {
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis'
};

export const hiddenFromContainer: Styles = {
	position: 'fixed',
	top: '-9999px',
	left: '-9999px',
	visibility: 'hidden'
};

export const caption = {
	fontSize: '0.875rem',
	fontStyle: 'normal',
	fontWeight: 400,
	lineHeight: '1.25rem',
	color: Colors.neutral700
};

export const captionStrong = {
	...caption,
	fontWeight: 500
};

export const disabledContent: Styles = {
	pointerEvents: 'none',
	opacity: 0.6
};

export const loading: Styles = {
	cursor: 'wait'
};

export const boldText: Styles = {
	fontWeight: 500
};

export const useCommonStyles = makeStyles(
	() =>
		createStyles({
			disabledContent,
			loading,
			boldText
		}),
	{
		name: 'Common'
	}
);

export const tabsCaptionSx: SxProps = {
	fontSize: '0.875rem',
	fontStyle: 'normal',
	fontWeight: 400,
	lineHeight: '1.25rem'
};

export const tabsCaptionStrongSx: SxProps = {
	...tabsCaptionSx,
	fontWeight: 500
};
